import ViewAccount from 'src/components/ViewAccount/ViewAccount';
import { connect } from 'react-redux';
import { FrameworkActionCreator, CustomerActionCreator, AppointmentActionCreator } from 'src/store/states';
import { IStoreState } from 'src/store';

const mapStateToProps = (state: IStoreState) => ({
    customerInfo: state.Customer.Customer,
    textCheckReturned: state.Customer?.textCheckReturned,
    mainPaneViewOrder: state.Framework.mainPaneViewOrder,
    specData: state.Specs.specs,
    locale: state.Framework.locale,
    specProfile: state.Framework.specProfile,
    store: state.Framework.store,
    branch: state.Framework.branch,
    previewFlag: state.Framework.previewFlag,
    theme: state.Framework.theme,
    errMsg: state.Customer.errMsg,
    retCode: state.Customer.retCode,
    changeCustReturned: state.Customer.changeCustReturned,
    apptCust: state.Appointment.ApptCust,
    vehicles: state.Vehicles.vehicles,
    selectedVehicle: state.Vehicles.selectedVehicle,
    countryCode: state.Framework.dealerCountry,
    identityVerified: state.Customer.identityVerified,
});

const mapDispatchToProps = {
    // clearMainPanes: FrameworkActionCreator.clearMainPanes,
    // pushToMainPanes: FrameworkActionCreator.pushToMainPane,
    popFromMainPane: FrameworkActionCreator.popFromMainPane,
    // setViewMode: FrameworkActionCreator.acSetViewMode,
    changeCustInfo: CustomerActionCreator.ChangeCustInfo,
    onCustUpdate: CustomerActionCreator.UpdateCustInfo,
    checkPhoneOptIn: CustomerActionCreator.CheckPhoneOptIn,
    clearTextCheckReturned: CustomerActionCreator.ClearTextCheckReturned,
    clearError: CustomerActionCreator.CustomerClearError,
    checkUniqueEmail: CustomerActionCreator.CheckUniqueEmail,
    addLogEntry: FrameworkActionCreator.addLogEntry,
    setChangeCustReturned: CustomerActionCreator.SetChangeCustReturned,
    onApptCustUpdate: AppointmentActionCreator.UpdateApptCust,
};

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(ViewAccount);